import { useCallback } from 'react';

import { useOrbitSessions } from 'api/orbit';

import { useOrbitContext } from './OrbitContext';
import { OrbitSession, OrbitSessionsParams } from './types';

/** Every chat, filed in a Workspace or not: only the full page's Recent leaves the filed ones out. */
export const ORBIT_ALL_CHATS: OrbitSessionsParams = {};

/**
 * A chat list (the panel's history and home, the full page's rail and folders), and resuming one of
 * its chats through the provider. Pass `null` to skip fetching.
 */
const useOrbitConversations = (params: OrbitSessionsParams | null) => {
  const { sessionId, resumeSession } = useOrbitContext();
  const list = useOrbitSessions(params);

  const select = useCallback(
    (session: OrbitSession) => {
      if (session.session_id !== sessionId) {
        resumeSession(session.session_id);
      }
    },
    [sessionId, resumeSession]
  );

  return { ...list, select };
};

export default useOrbitConversations;
